import Axios from "axios";
import {mainUrl} from "../../common/common";
import {CardBody, Input} from "reactstrap";
import {Button, Col, FormGroup, Row} from "react-bootstrap";
import React from "react";


function SearchEmployee(props) {

    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Header': '*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    }
    const searchStaff = async (e) => {
        e.preventDefault();
        const f = e.target;
        props.setSearchParameter({
            'phone': f.sh_phone_number.value,
            'branch_id': f.sh_branch_id.value,
            'position_id': f.sh_position_id.value,
            'employee_id': f.sh_employee_id.value
        });
        props.setSearchStatus(true);
        const {data} = await Axios.post(mainUrl + "searchStaff?page=1",
            {
                'phone': f.sh_phone_number.value,
                'branch_id': f.sh_branch_id.value,
                'position_id': f.sh_position_id.value,
                'employee_id': f.sh_employee_id.value
            }, {headers});
        const lists = data;
        props.setList(lists);
    };

    return (
        <>
            <CardBody className="mr-4 ml-4" style={{minHeight:"100%"}}>
                <form onSubmit={(e) => searchStaff(e)}>
                    <Row>
                        <Col className="pl-1" md="3">
                            <FormGroup>
                                <label> Employee Id <span
                                    className="text text-danger">*</span></label>
                                <input className="form-control" title="Employee Id" name="sh_employee_id" id="sh_employee_id"
                                       placeholder="Employee Id" type="text"/>
                            </FormGroup>
                        </Col>
                        <Col className="pl-1" md="3">
                            <FormGroup>
                                <label> Phone Number <span
                                    className="text text-danger">*</span></label>
                                <input className="form-control" title="Phone Number" name="sh_phone_number" id="sh_phone_number"
                                       placeholder="Phone Number" type="number"/>
                            </FormGroup>
                        </Col>
                        <Col className="px-1" md="3">
                            <FormGroup>
                                <label>Branch <span className="text text-danger">*</span></label>
                                <select title="Select Branch" name="sh_branch_id" id="sh_branch_id"
                                        className="form-control">
                                    <option value=""></option>
                                    {props.branchList.map((e, index) => (
                                        <option key={index}
                                                value={e.id}>{e.name}</option>
                                    ))}
                                </select>
                            </FormGroup>
                        </Col>
                        <Col className="px-1" md="3">
                            <FormGroup>
                                <label>Position <span className="text text-danger">*</span></label>
                                <select  title="Select Position" name="sh_position_id" id="sh_position_id"
                                        className="form-control">
                                    <option value=""></option>
                                    {props.positionList.map((e) => (
                                        <option key={e.id}
                                                value={e.id}>{e.name}</option>
                                    ))}
                                </select>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <div className="ml-end">
                            <Button title="Search" className="btn btn-danger btn-round" type="submit">
                                <span className="nc-icon nc-zoom-split"/>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                Search
                                &nbsp;
                            </Button>
                        </div>
                    </Row>
                </form>
            </CardBody>
        </>
    );
}


export default SearchEmployee;
